<div
    class="log-cinematic-end-to-end-bridge"
    [ngClass]="{ 'log-cinematic-end-to-end-bridge--no-arrow': noArrow }"
>
    <!-- over arrow part -->
    <div
        *ngIf="!isHeaderClickable; else headerClickable"
        class="log-cinematic-end-to-end-bridge__title"
        [ngClass]="'log-cinematic-end-to-end-bridge__title--' + topHeaderColor"
    >
        {{ topHeader }}
    </div>
    <div class="log-cinematic-end-to-end-bridge__time">
        <ng-container *ngIf="endToEndTime !== undefined; else na">
            <span
                *ngIf="isTimeUnitFilterable; else timeUnitNotFilterable"
                logFilterList
                [property]="endToEndTimeFilterProp"
                [value]="endToEndTime"
                displayValue="{{ displayValue }} {{ globalL10nKeys.msLabel | vtranslate }}"
                (onFilterAdd)="onFilterAdd.emit()"
            >
                <ng-container *ngTemplateOutlet="timeUnit"></ng-container>
            </span>
            <span class="log-cinematic-end-to-end-bridge__time-unit">
                {{ globalL10nKeys.msLabel | vtranslate }}
            </span>
        </ng-container>
        <ng-template #na>
            <div logEmptyField></div>
        </ng-template>
    </div>

    <!-- arrow -->
    <double-arrow
        *ngIf="!noArrow"
        class="log-cinematic-end-to-end-bridge__arrow"
        [color]="arrowColor"
    ></double-arrow>

    <!-- under arrow part -->
    <ng-container *ngIf="!noStatusCode">
        <div class="log-cinematic-end-to-end-bridge__title">
            {{ globalL10nKeys.responseCodeLabel | vtranslate }}
        </div>
        <div class="log-cinematic-end-to-end-bridge__status-code">
            <span
                *ngIf="statusCode !== undefined; else emDash"
                logFilter
                [property]="statusCodeFilterProp"
                [value]="statusCode"
                (onFilterAdd)="onFilterAdd.emit()"
            >
                {{ statusCode }}
            </span>
            <ng-template #emDash>
                <div
                    logEmptyField
                    [useDash]="true"
                ></div>
            </ng-template>
        </div>
    </ng-container>
</div>

<ng-template #headerClickable>
    <div
        class="log-cinematic-end-to-end-bridge__title log-cinematic-end-to-end-bridge__title-clickable"
        [ngClass]="['log-cinematic-end-to-end-bridge__title--' + topHeaderColor, isActive ? 'log-cinematic-end-to-end-bridge__title--active': '']"
        (click)="onHeaderClick.emit()"
    >
        {{ topHeader }}
    </div>
</ng-template>

<ng-template #timeUnit>
    <ng-container *ngIf="isWafTiming || endToEndTime >= endToEndTimeLowerLimit; else lessThanOne">
        {{ displayValue }}
    </ng-container>
    <ng-template #lessThanOne>
        &lt; {{ endToEndTimeLowerLimit }}
    </ng-template>
</ng-template>

<ng-template #timeUnitNotFilterable>
    <span>
        <ng-container *ngTemplateOutlet="timeUnit"></ng-container>
    </span>
</ng-template>
